import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import { Container, Row, Col, CardBody, Card, Button, Alert } from "reactstrap"


// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

// import images
//import logoImg from "assets/images/logo/cargills_GO.png"
import logo from "assets/images/logo/mySky.png"
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import user from "../../assets/images/users/avatar-1.jpg"
import CarouselPage from "./CarouselPage"

const host = window.location.protocol + "//" + window.location.host;
import Config, { ActiveClient } from "../../config";
var LogoSet = (ActiveClient) ? Config[ActiveClient] : Config["cargills"];
//console.log(LogoSet);

var logoImg = logo;
import(`../../assets/images/logo/${LogoSet.logo}`).then(data => {
  logoImg = host + data.default; //console.log(logo);
});

import { useHistory } from "react-router-dom";
const LockScreen = (props) => {


  const obj = JSON.parse(localStorage.getItem("authUser"))
  const [strUsername, setUsername] = useState(obj[2])
  const [strPassword, setPassword] = useState('')
  const [selectedloc, setselectedloc] = useState(obj[3])
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')

  const history = useHistory(); // Create a history object

  /* Changed by : Madhura Liyanage
    Changed On : 30/11/2022
    Reason : Changed all image storage/accessing location to media server
  */
  //---------Beginning of change ---------------------------------------------------------------------------------------------------------------

  const [usrImg, setusrImg] = useState(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/user/${obj[1]}`);
  //---------End of change ---------------------------------------------------------------------------------------------------------------



  // handleValidSubmit
  const handleValidSubmit = async (event, values) => {
    //debugger;
    //dispatch(loginUser(values, props.history))    
    if (selectedloc == null) {
      setAlertColor("danger")
      setAlertMsg("Please select Location !")
      setShow(true)
      return
    }
    const Logindet = { strUsername, strPassword }
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${authToken}`);

    var raw = JSON.stringify({
      "strUsername": strUsername,
      "strPassword": strPassword,
      "strLocation": selectedloc
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    await fetch(`${ApiURL}login`, requestOptions)
      .then(response => {
        console.log(response)
        if (response.status == "200") {
          response.json()
            .then(responseData => {
              localStorage.removeItem("authPark")
              // window.location.href = "/";
              history.push("/");
              return;
            })
        } else if (response.status == "403") {
          setAlertColor("danger")
          setAlertMsg("Invalid Access to Location !")
          setShow(true)

        } else if (response.status == "404") {
          setAlertColor("danger")
          setAlertMsg("Invalid Login Details !")
          setShow(true)

        } else if (response.status == "400") {
          setAlertColor("danger")
          setAlertMsg("Unexpected error!")
          setShow(true)
        }

      })
      .catch(error => console.log('error', error));

  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Lock Screen</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <CarouselPage />
            <Col xl={3}>
              <div className="auth-full-page-content p-md-5 p-4">
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <div className="mb-4 mb-md-5">
                      <Link to="dashboard"
                        className="d-block auth-logo">
                        <img
                          src={logoImg}
                          alt=""
                          height="50"
                          className="auth-logo-dark"
                        />
                        <img
                          src={logolight}
                          alt=""
                          height="18"
                          className="auth-logo-light"
                        />
                      </Link>
                    </div>
                    <div className="my-auto">
                      <div>
                        <h5 className="text-primary">Lock screen</h5>
                        <p className="text-muted">
                          Enter your password to unlock the screen!
                        </p>
                      </div>

                      <div className="mt-4">
                        <AvForm className="form-horizontal">
                          {props.error && props.error ? (
                            <Alert color="danger">{props.error}</Alert>
                          ) : null}

                          <div className="user-thumb text-center mb-4">
                            <img
                              src={usrImg}
                              className="rounded-circle img-thumbnail avatar-md"
                              alt="thumbnail"
                            />
                            <h5 className="font-size-15 mt-3">{obj[0]}</h5>
                          </div>

                          <div className="mb-3">
                            <AvField
                              name="password"
                              label="Password"
                              type="password"
                              required
                              value={strPassword}
                              onChange={(e) => {
                                setPassword(e.target.value)
                              }}
                              placeholder="Enter Password"
                            />
                          </div>

                          <div className="text-end">
                            <Col xs="12" className="text-end">
                              <Button
                                color="primary"
                                className=" w-md "
                                type="button"
                                onClick={handleValidSubmit}
                              >
                                Unlock
                              </Button>
                            </Col>
                          </div>
                        </AvForm>
                        <div className="mt-5 text-center">
                          <p>
                            Not you ? return{" "}
                            <Link
                              to="/login"
                              className="fw-medium text-primary"
                            >
                              {" "}
                              Sign In{" "}
                            </Link>{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4 mt-md-5 text-center">
                      <p>
                      © {new Date().getFullYear()} <a href={Config[Config.ActiveClient].webUrl}>{Config[Config.ActiveClient].fullName}</a>{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default LockScreen;
